export var ItemType;
(function (ItemType) {
    ItemType[ItemType["Empty"] = 0] = "Empty";
    ItemType[ItemType["Text"] = 1] = "Text";
    ItemType[ItemType["Input"] = 2] = "Input";
    ItemType[ItemType["List"] = 3] = "List";
})(ItemType || (ItemType = {}));
